import gql from 'graphql-tag';

export const getMonLogTypes = gql`
  query queryForMonLogTypes(
    $limit: Int
    $page: Int
    $query: MonLogTypeSortOrQuery
    $sort: MonLogTypeSortOrQuery
  ) {
    queryForMonLogTypes(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        name
        enabled
        version
        requiresCRER
      }
      totalRecords
    }
  }
`;
